// This code is for cart drawer
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink =
      document.querySelector(".header_cart_is_drawer") ||
      document.querySelector(".header_cart");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");

    const openCart = (event) => {
      event.preventDefault();
      this.open(cartLink);
    };

    cartLink.addEventListener("click", openCart);
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") openCart(event);
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => this.classList.add("animate", "active"));

    this.addEventListener(
      "transitionend",
      () => {
        const container = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__empty-state")
          : document.getElementById("CartDrawer");
        trapFocus(
          container,
          this.querySelector(".drawer__inner") ||
            this.querySelector(".cart-close")
        );
      },
      { once: true }
    );
  }

  // close sidecart
  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    const cartDrawer = document.querySelector(".drawer_cart");
    const focusableElements = cartDrawer.querySelectorAll(
      "button, input, a, .cart-drawer, summary, cart-item-list"
    ); // Interactive elements

    focusableElements.forEach((el) => el.setAttribute("tabindex", "-1"));
  }

  // setSummaryAccessibility
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }


  renderContents(parsedState) {
    const drawerInner = this.querySelector(".drawer__inner");
    drawerInner.classList.contains("is-empty") &&
    drawerInner.classList.remove("is-empty");

    this.productId = parsedState.id;

    if(Shopify.designMode) {
      window.location.href = Shopify.routes.root + 'cart/';
    }

    this.getSectionsToRender().forEach(({ id, selector }) => {
      const sectionElement = selector
        ? document.querySelector(selector)
        : document.getElementById(id);
      sectionElement.innerHTML = this.getSectionHTML(
        parsedState.sections[id],
        selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      // Honax: Warenkorb nach "In den Warenkorb" NICHT automatisch oeffnen,
      // stattdessen kurze Bestaetigung einblenden.
      this.showAddedToast();
    });

    const cartUpdatedEvent = new CustomEvent("cart:updated", {
          detail: {
            cartData: parsedState,
          },
        });
        window.dispatchEvent(cartUpdatedEvent);
  }

  // Honax: kurze Bestaetigung nach dem Hinzufuegen
  showAddedToast() {
    const de = (document.documentElement.lang || "").toLowerCase().indexOf("de") === 0;
    let toast = document.getElementById("honax-cart-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.id = "honax-cart-toast";
      toast.setAttribute("role", "status");
      toast.style.cssText =
        "position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(20px);" +
        "background:#1a2a0d;color:#fff;padding:12px 18px;border-radius:8px;" +
        "box-shadow:0 6px 20px rgba(0,0,0,.2);z-index:2147483000;display:flex;" +
        "align-items:center;gap:14px;font-size:15px;opacity:0;transition:opacity .25s,transform .25s;" +
        "max-width:calc(100vw - 32px)";
      const text = document.createElement("span");
      text.textContent = de ? "✓ Zum Warenkorb hinzugefügt" : "✓ Added to cart";
      const btn = document.createElement("button");
      btn.type = "button";
      btn.textContent = de ? "Ansehen" : "View";
      btn.style.cssText =
        "background:#729919;color:#fff;border:0;border-radius:6px;padding:6px 12px;" +
        "font:inherit;cursor:pointer;white-space:nowrap";
      btn.addEventListener("click", () => {
        toast.style.opacity = "0";
        toast.style.pointerEvents = "none";
        this.open();
      });
      toast.appendChild(text);
      toast.appendChild(btn);
      document.body.appendChild(toast);
    }
    clearTimeout(this._toastTimer);
    toast.style.pointerEvents = "auto";
    requestAnimationFrame(() => {
      toast.style.opacity = "1";
      toast.style.transform = "translateX(-50%) translateY(0)";
    });
    this._toastTimer = setTimeout(() => {
      toast.style.opacity = "0";
      toast.style.pointerEvents = "none";
      toast.style.transform = "translateX(-50%) translateY(20px)";
    }, 3500);
  }


  // getSectionHTML
  getSectionHTML(html, selector = ".shopify-section") {
    const section = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
    return section ? section.innerHTML : "";
  }

  getSectionsToRender() {
    return [
      { id: "cart-drawer", selector: "#CartDrawer" },
      { id: "cart-icon-bubble" },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-item-list", CartDrawerItems);

// CART DRAWER ACCESSIBILITY
document.addEventListener("DOMContentLoaded", function () {
  const cartDrawer = document.querySelector(".drawer_cart"); // Update with actual ID
  const DrawerInner = cartDrawer.querySelector(".drawer__inner");
  const focusableElements = cartDrawer.querySelectorAll(
    "button, input, a, .cart-drawer, summary, cart-item-list"
  ); // Interactive elements
  const closeButton = cartDrawer.querySelector(".cart-close"); // Update selector

  function disableSearchFocus() {
    focusableElements.forEach((el) => el.setAttribute("tabindex", "-1"));
  }

  function opencartDrawer(event) {
    if (event.key === "Enter" || event.keyCode === 13) {
      event.preventDefault();
      cartDrawer.classList.add("active");
      cartDrawer.setAttribute("aria-hidden", "false");

      // Enable focus
      focusableElements.forEach((el) => el.setAttribute("tabindex", "0"));
      trapFocus(cartDrawer, DrawerInner);
    }
  }

  function closecartDrawer() {
    cartDrawer.classList.remove("active");
    cartDrawer.setAttribute("aria-hidden", "true");

    disableSearchFocus();
  }

  disableSearchFocus();

  closeButton.addEventListener("click", closecartDrawer);
  cartDrawer.addEventListener("keydown", function (event) {
    if (event.key === "Escape" || event.keyCode === 27) {
      closecartDrawer();
    }
  });
});
